module.exports = __webpack_public_path__ + "img/mail-01.d16d17c8.svg";